var map = {
	"./assessmentThankYou/tereza.webp": 72542,
	"./digistart/pageHeader/header.webp": 41352,
	"./indexHero/indexHeroCarousel/0.webp": 97134,
	"./indexHero/indexHeroCarousel/0_50.webp": 67949,
	"./indexHero/indexHeroCarousel/1.webp": 23892,
	"./indexHero/indexHeroCarousel/1_50.webp": 33042,
	"./indexHero/indexHeroVideo/video.webp": 5914,
	"./lectures/pageHeader/header-hd.webp": 58866,
	"./lectures/pageHeader/header-lg.webp": 53285,
	"./lectures/pageHeader/header-xxl.webp": 43000,
	"./lectures/pageHeader/header.webp": 41322,
	"./microsoft365/microsoft365About/cyber-security.webp": 22794,
	"./microsoft365/microsoft365About/microsoft-365.webp": 33420,
	"./microsoft365/microsoft365About/microsoft-azure.webp": 755,
	"./microsoft365/microsoft365About/power-automate.webp": 7609,
	"./microsoft365/microsoft365About/power-bi.webp": 29280,
	"./microsoft365/microsoft365About/students.webp": 39956,
	"./microsoft365/microsoft365More/cyber-security.webp": 73536,
	"./microsoft365/microsoft365More/microsoft-365.webp": 25773,
	"./microsoft365/microsoft365More/microsoft-azure.webp": 67130,
	"./microsoft365/microsoft365More/power-automate.webp": 40053,
	"./microsoft365/microsoft365More/power-bi.webp": 71032,
	"./microsoft365/microsoft365Study/9.webp": 12103,
	"./microsoft365/pageHeader/header-hd.webp": 7813,
	"./microsoft365/pageHeader/header-lg.webp": 32440,
	"./microsoft365/pageHeader/header-xxl.webp": 78473,
	"./microsoft365/pageHeader/header.webp": 47963,
	"./students/pageHeader/header-hd.webp": 22046,
	"./students/pageHeader/header-lg.webp": 6020,
	"./students/pageHeader/header-xxl.webp": 59573,
	"./students/pageHeader/header.webp": 18634,
	"./studyProgram/pageHeader/header-hd.webp": 31067,
	"./studyProgram/pageHeader/header-lg.webp": 62301,
	"./studyProgram/pageHeader/header-xxl.webp": 30136,
	"./studyProgram/pageHeader/header.webp": 80598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15336;